var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pb-30" },
    [
      _c(
        "md-card",
        { staticClass: "mt-30 response-filter" },
        [
          _c(
            "md-card-header",
            { staticClass: "ask-subject community-filter-custome" },
            [
              _c("div", { staticClass: "md-layout sort-order-xsmall-100" }, [
                _c("div", { staticClass: "md-layout-item" }, [
                  _c("label", [_vm._v("Responses")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "md-layout-item" },
                  [
                    _c(
                      "md-field",
                      { staticClass: "align-right create-community w-50" },
                      [
                        _c(
                          "md-select",
                          {
                            attrs: {
                              name: "community",
                              placeholder: "Community",
                              id: "community",
                              "aria-label": "Select community to filter"
                            },
                            model: {
                              value: _vm.selectedCommunity,
                              callback: function($$v) {
                                _vm.selectedCommunity = $$v
                              },
                              expression: "selectedCommunity"
                            }
                          },
                          [
                            _c("md-option", { attrs: { value: "all" } }, [
                              _vm._v("All")
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.allCommunities, function(
                              singleCommunity
                            ) {
                              return _c(
                                "md-option",
                                {
                                  key: singleCommunity._id,
                                  attrs: { value: singleCommunity._id }
                                },
                                [_vm._v(_vm._s(singleCommunity.name))]
                              )
                            })
                          ],
                          2
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.count == "0"
        ? _c(
            "div",
            [
              _c("md-empty-state", {
                attrs: {
                  "md-label": "No Response Found",
                  "md-description": "Please select another community."
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.responses, function(response) {
        return _vm.count && _vm.count > 0
          ? [
              _vm.$lodash.has(response.ask, "text")
                ? _c(
                    "md-card",
                    { key: response.ask._id, staticClass: "mt-30" },
                    [
                      _c(
                        "md-card-header",
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "remove-link",
                              attrs: {
                                to: "/asks/" + response.ask._id + "/request"
                              }
                            },
                            [
                              _c("div", {
                                staticClass: "ask-subject",
                                style: {
                                  backgroundColor:
                                    response.community.customSettings
                                      .primaryColor,
                                  color:
                                    response.community.customSettings
                                      .secondaryColor
                                },
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$lodash.has(response.community, "name")
                                      ? response.community.name +
                                          ": " +
                                          response.ask.subject
                                      : response.ask.subject
                                  )
                                }
                              })
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "md-card-content",
                        { staticClass: "md-scrollbar scrollbar" },
                        [
                          _c(
                            "md-table",
                            { staticClass: "response-section-table" },
                            [
                              _c(
                                "md-table-row",
                                [
                                  _c(
                                    "md-table-head",
                                    {
                                      staticClass:
                                        "card-header remove-table-head-margin"
                                    },
                                    [_vm._v("Adviser")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "md-table-head",
                                    {
                                      staticClass:
                                        "card-header remove-table-head-margin"
                                    },
                                    [_vm._v("Email")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "md-table-head",
                                    {
                                      staticClass:
                                        "card-header remove-table-head-margin"
                                    },
                                    [_vm._v("Community")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "md-table-head",
                                    {
                                      staticClass:
                                        "card-header remove-table-head-margin"
                                    },
                                    [_vm._v("Received")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "md-table-head",
                                    {
                                      staticClass:
                                        "card-header remove-table-head-margin"
                                    },
                                    [_vm._v("Responded")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "md-table-head",
                                    {
                                      staticClass:
                                        "card-header remove-table-head-margin"
                                    },
                                    [_vm._v("Status")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "md-table-head",
                                    {
                                      staticClass:
                                        "card-header remove-table-head-margin"
                                    },
                                    [_vm._v("Response")]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm._l(response.ask.gives, function(give, index) {
                                return [
                                  ["In Review", "Pending"].includes(
                                    give.responseState.currentState
                                  ) &&
                                  give.helpaction == "yes" &&
                                  ([
                                    "Insight",
                                    "Share Advice",
                                    "Call Me"
                                  ].includes(give.action) ||
                                    give.action.search(/Let's Connect/i) == 0)
                                    ? _c(
                                        "md-table-row",
                                        {
                                          key: give._id,
                                          staticClass: "response-section",
                                          on: {
                                            click: function($event) {
                                              _vm.expandResponseSection(
                                                give._id
                                              )
                                              _vm.giveId = give._id
                                            }
                                          }
                                        },
                                        [
                                          give.advisors && give.advisors.length
                                            ? _c("md-table-cell", [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "display-link",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.goToProfile(
                                                          give.advisors[0]._id
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        give.advisors &&
                                                          give.advisors.length
                                                          ? _vm.getAdviserByName(
                                                              give.advisors
                                                            )
                                                          : "N/A"
                                                      )
                                                    )
                                                  ]
                                                )
                                              ])
                                            : _c("md-table-cell", [
                                                _vm._v("N/A")
                                              ]),
                                          _vm._v(" "),
                                          _c("md-table-cell", [
                                            _vm._v(
                                              _vm._s(
                                                give.advisors &&
                                                  give.advisors.length
                                                  ? _vm.getAdviserByEmail(
                                                      give.advisors
                                                    )
                                                  : give.email
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("md-table-cell", [
                                            _vm._v(
                                              _vm._s(
                                                response.community
                                                  ? response.community.name
                                                  : "N/A"
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("md-table-cell", [
                                            _vm._v(
                                              _vm._s(
                                                give.advisors &&
                                                  give.advisors.length
                                                  ? _vm.getAdviserRequestDate(
                                                      response.ask,
                                                      give.advisors[0]._id
                                                    )
                                                  : "N/A"
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("md-table-cell", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("momentDate")(give.when)
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          give.responseState.currentState
                                            ? _c(
                                                "md-table-cell",
                                                {
                                                  class: [
                                                    {
                                                      "md-orange-color": [
                                                        "In Review",
                                                        "Pending"
                                                      ].includes(
                                                        give.responseState
                                                          .currentState
                                                      )
                                                    },
                                                    {
                                                      "md-green-color":
                                                        give.responseState
                                                          .currentState ===
                                                        "Approved"
                                                    },
                                                    {
                                                      "md-red-color":
                                                        give.responseState
                                                          .currentState ===
                                                        "Rejected"
                                                    }
                                                  ]
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      give.responseState
                                                        .currentState
                                                    )
                                                  )
                                                ]
                                              )
                                            : _c("md-table-cell", [
                                                _vm._v("N/A")
                                              ]),
                                          _vm._v(" "),
                                          _c("md-table-cell", [
                                            _vm._v(
                                              _vm._s(
                                                give.action
                                                  ? _vm.getResponseAction(
                                                      give.action
                                                    )
                                                  : "Advice"
                                              )
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.responseSectionArr.includes(give._id) &&
                                  give.responseState.currentState !=
                                    "Approved" &&
                                  give.responseState.currentState != "Pending"
                                    ? _c(
                                        "div",
                                        {
                                          key: "approve-response-" + give._id,
                                          staticClass: "table-row mt-20"
                                        },
                                        [
                                          _c(
                                            "md-table-cell",
                                            { attrs: { colspan: "7" } },
                                            [
                                              give.action != "Call Me"
                                                ? _c("textarea", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model.trim",
                                                        value: give.insight,
                                                        expression:
                                                          "give.insight",
                                                        modifiers: {
                                                          trim: true
                                                        }
                                                      }
                                                    ],
                                                    staticClass:
                                                      "response-description",
                                                    attrs: {
                                                      id:
                                                        "response-id-" + index,
                                                      "data-id":
                                                        "response-id-" + index
                                                    },
                                                    domProps: {
                                                      value: give.insight
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        return _vm.editResponse(
                                                          response.ask._id,
                                                          give
                                                        )
                                                      },
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          give,
                                                          "insight",
                                                          $event.target.value.trim()
                                                        )
                                                      },
                                                      blur: function($event) {
                                                        return _vm.$forceUpdate()
                                                      }
                                                    }
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "md-card-actions",
                                                { staticClass: "card-actions" },
                                                _vm._l(
                                                  give.responseState
                                                    .availableStates,
                                                  function(action) {
                                                    return _c(
                                                      "md-button",
                                                      {
                                                        key: action,
                                                        class: [
                                                          {
                                                            "md-orange":
                                                              action ===
                                                              "Reject"
                                                          },
                                                          "md-raised",
                                                          "md-accent",
                                                          "md-round",
                                                          "float-right",
                                                          "capitalize",
                                                          "md-white-color",
                                                          "m-left-10"
                                                        ],
                                                        attrs: {
                                                          interaction: action
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.doInteraction(
                                                              response.ask._id,
                                                              give._id,
                                                              action
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(action) +
                                                            "\n                                    "
                                                        )
                                                      ]
                                                    )
                                                  }
                                                ),
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ]
                              })
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]
          : _vm._e()
      }),
      _vm._v(" "),
      _vm.skip + _vm.limit < _vm.count
        ? _c(
            "md-button",
            {
              staticClass: "md-fab loadmore-button",
              attrs: { "aria-label": "Load more results" },
              on: {
                click: function($event) {
                  return _vm.loadMore()
                }
              }
            },
            [
              _c("md-tooltip", { attrs: { "md-direction": "left" } }, [
                _vm._v("Load more")
              ]),
              _vm._v(" "),
              _c(
                "md-icon",
                [_c("font-awesome-icon", { attrs: { icon: "recycle" } })],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4aa2b9c2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4aa2b9c2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewResponses.vue
// module id = null
// module chunks = 